import { useState } from "react";
import { Link } from "react-router-dom";
import ContactModal from "@/components/ContactModal";

// Reusable footer links + copyright + contact modal.
// `tone` controls link colour so it fits both dark and light footers.
export default function FooterLinks({ tone = "dark", align = "end" }) {
  const [contactOpen, setContactOpen] = useState(false);
  const linkClass = tone === "dark" ? "text-white/60 hover:text-white" : "text-muted-foreground hover:text-foreground";
  const copyClass = tone === "dark" ? "text-white/40" : "text-muted-foreground/70";
  const alignClass = align === "center" ? "items-center text-center" : "items-end text-right";

  return (
    <div className={`flex flex-col gap-1 ${alignClass}`}>
      <div className="flex items-center gap-4 text-xs">
        <button type="button" onClick={() => setContactOpen(true)} className={linkClass} data-testid="footer-contact">
          Contact
        </button>
        <Link to="/privacy" className={linkClass} data-testid="footer-privacy">Privacy</Link>
        <Link to="/terms" className={linkClass} data-testid="footer-terms">Terms</Link>
      </div>
      <span className={`text-[11px] ${copyClass}`} data-testid="footer-copyright">
        © {new Date().getFullYear()} Sim Racing Connected. All rights reserved.
      </span>
      <ContactModal open={contactOpen} onOpenChange={setContactOpen} />
    </div>
  );
}
